<div class="login-container">
  <div class="login-card mat-elevation-z4">
    <div class="login-header">
      <mat-icon class="logo-icon">local_shipping</mat-icon>
      <h1>Gate Pass Management</h1>
      <p>Sign in to your account</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <mat-form-field appearance="outline">
        <mat-label>Username or Email</mat-label>
        <input matInput formControlName="username" autocomplete="username" placeholder="Enter username or email">
        <mat-icon matSuffix>person</mat-icon>
        <mat-error *ngIf="loginForm.get('username')?.hasError('required')">Username is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="current-password">
        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
          <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="loginForm.get('password')?.hasError('required')">Password is required</mat-error>
        <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">Minimum 6 characters</mat-error>
      </mat-form-field>

      <button mat-raised-button color="primary" type="submit" class="login-btn" [disabled]="loading">
        <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
        <span *ngIf="!loading">Sign In</span>
      </button>
    </form>

    <div class="login-hint">
      <p>Default admin: <strong>admin / Admin&#64;123</strong></p>
    </div>
  </div>
</div>
